
import { Skeleton } from '@chakra-ui/react'
import React, {useState, useCallback, useEffect} from 'react'
import client from '../client.js'
import {Link} from 'react-router-dom'
// import { RecipeContext } from './context/RecipeContext.js'

import Layout from './Layout'

function Dessert() {

  
  const [dessert, setDessert] = useState([])
  const [isDessertLoading, setIsDessertLoading] = useState(false)

  const cleanUpDessert = useCallback((rawData) => {

      const cleanDessert = rawData.map((category) =>{

          const {sys, fields} =category
          const {id} = sys
          const recipeTitle = fields.recipeName
          const recipeImage = fields.recipePicture.fields.file.url
          const cleanedAppetizer = {id, recipeTitle, recipeImage}
          return cleanedAppetizer
      })
      setDessert(cleanDessert)
      

  },[])

  const fetchDessert = useCallback (async () => {
      
      try {

          const response = await client.getEntries({content_type:'recipeNookRecipes'})
          const responseData = response.items.filter(recipes => recipes.fields.mealType === "Dessert")
          console.log(responseData)
           console.log("try/catch:" + response)
          if (responseData) {
              cleanUpDessert(responseData)
              setIsDessertLoading(true)
          } else {
              setDessert([])
              setIsDessertLoading(false)
          }
          
      } 
      catch (error) {
          console.log(error)
          setIsDessertLoading(false)
      }
  },[cleanUpDessert])

  useEffect(() => {
    fetchDessert()
  }, [fetchDessert])

  // console.log("End of Function" + entrees)
 




  return (
 
    <Layout>
        <Skeleton isLoaded={isDessertLoading} height={'89vh'} fadeDuration={1}>
          <section id="entrees" className='flex my-10  h-[100vh] items-center xs:flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-col ' >
            <div className='mb-4'>
              <span className='title text-4xl text-rosemadder font-nunito '>Dessert</span>
            </div>
            
            <div className='tilesContainer'>
                {dessert.map((item) => {
                    const {id, recipeTitle, recipeImage} = item

                return (
                        <Link to={`/category/Entree/${id}/${recipeTitle}/`}>
                            <div key={id} className="categoryTiles" style={{background:`url(${recipeImage})`, backgroundSize:'cover', width:'300px', height:'300px',backgroundPosition:'center', borderRadius:'30px'}}>
                                <div className=' bg-black/40 w-full h-full flex flex-col justify-center rounded-[30px] items-center'>
                                    <h2 className='font-bold font-nunito text-white text-2xl'>{recipeTitle}</h2>
                                </div>
                                
                            </div>
                        </Link>
                )
                })}
            </div>
          </section>
        </Skeleton>
    </Layout>
  )
}

export default Dessert